<template>
  <div>
    <el-card shadow="always">
      <div slot="header">Your Account</div>
      <div slot="actions">
        <router-link class="forgot-password-link" :to="{ name: 'resetPassword' }"><a>{{ $t(`${translationPrefix}.buttons.forgotPassword`) }}</a></router-link>
      </div>
      <el-form
        ref="loginForm"
        :model="formData"
        :rules="rules"
        :label-width="$root.labelWidth"
        label-position="right"
        v-loading="authenticating"
      >
        <el-row>
          <el-col :span="20" :offset="2">
            <el-form-item :label="$t('modules.user.fields.email.label')" prop="email">
              <el-input type="email" class="gray" @keyup.enter.native="submitForm('loginForm')" v-model.lazy.trim="formData.email" :placeholder="$t('modules.user.fields.email.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('modules.user.fields.password.label')" prop="password">
              <el-input type="password" class="gray" @keyup.enter.native="submitForm('loginForm')" v-model.lazy.trim="formData.password" :placeholder="$t('modules.user.fields.password.placeholder')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formData.rememberMe">Remember Me</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col :span="24" align="center">
                  <el-button type="primary" class="button" @click="submitForm('loginForm')">{{ $t('buttons.submit') }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import validations from '@/utils/validations';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'Login',
    created() {
      if (this.$router.currentRoute.query.account_confirmation_success === 'true') {
        showSuccessMessage(this.$t('modules.user.messages.confirmed'));
      }
      if (localStorage.email !== undefined) {
        this.formData.rememberMe = true;
        this.formData.email = localStorage.email;
      }
    },
    data() {
      return {
        translationPrefix: 'components.login',
        appName: this.$router.currentRoute.query.app_name || null,
        redirectUrl: this.$router.currentRoute.query.redirect || '/dashboard',
        rules: {
          email: [
            { ...validations.required },
            { ...validations.email },
          ],
          password: [
            { ...validations.required },
          ],
        },
        formData: {
          email: '',
          password: '',
          rememberMe: false,
        },
      };
    },
    computed: {
      ...mapGetters('entities/users', ['authenticating', 'currentUser']),
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            localStorage.email = this.formData.email;
            this.$store.dispatch('entities/users/login', { email: this.formData.email, password: this.formData.password })
              .then((response) => {
                if (response.status) {
                  showSuccessMessage(this.$t('modules.user.messages.loggedIn'));

                  if (this.appName) {
                    if (this.$store.getters['entities/users/isSubscribed'](this.appName)) {
                      window.location.href = this.redirectUrl;
                    } else {
                      this.$router.push({ name: 'dashboard' });
                    }
                  } else {
                    this.$router.push(this.redirectUrl || { name: 'dashboard' });
                  }
                } else {
                  showErrorMessage(response.error);
                }
              });
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
    },
  };
</script>

<style lang="scss">
  .button{
    width: 100%;
  }

  .gray{
    background-color: rgba(#000000,0.05);
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Login.vue